<script lang="ts">
  /**
   * Reusable Button Component
   *
   * Usage:
   * <Button variant="primary" loading={isSubmitting} onclick={handleSubmit}>
   *   Submit
   * </Button>
   */

  import type { Snippet } from 'svelte';

  type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'cancel' | 'icon';
  type ButtonSize = 'small' | 'medium' | 'large';

  interface Props {
    variant?: ButtonVariant;
    size?: ButtonSize;
    loading?: boolean;
    disabled?: boolean;
    type?: 'button' | 'submit' | 'reset';
    title?: string;
    onclick?: (e: MouseEvent) => void;
    children?: Snippet;
  }

  let {
    variant = 'primary',
    size = 'medium',
    loading = false,
    disabled = false,
    type = 'button',
    title = '',
    onclick,
    children
  }: Props = $props();

  let sizeClass = $derived(
    size === 'small' ? 'btn-small' :
    size === 'large' ? 'btn-large' : ''
  );

  let buttonClass = $derived(
    variant === 'icon'
      ? 'btn-icon'
      : `btn-${variant} ${sizeClass}`.trim()
  );
</script>

<button
  class={buttonClass}
  {type}
  title={title || undefined}
  disabled={disabled || loading}
  {onclick}
>
  {#if loading}
    <span class="spinner spinner-small"></span>
  {/if}
  {#if children}
    {@render children()}
  {/if}
</button>
